<template>
  <b-card id="page-inventory-kardex" no-body class="mb-0 p-2">
    <b-card-header>
      <b-card-title>
        <h2>{{ $t(label("title")) }}</h2>
      </b-card-title>
      <b-button variant="primary" @click="goBack">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>

    <b-card-body class="px-0">
      <!-- <b-alert v-if="!companyGuid" show variant="warning">
        {{ $t(label("selectCompany")) }}
      </b-alert> -->

      <b-row class="px-2">
        <b-col cols="12" md="6">
          <b-form-group :label="$t(label('product'))">
            <v-select
              v-model="guidProduct"
              :options="products"
              label="name"
              :reduce="(option) => option.guid"
              :placeholder="$t(label('selectProduct'))"
              :disabled="!companyGuid"
              @input="onProductChange"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <Filterss
        :fields="fildsToFilters"
        :model="model"
        @filter-applied="applyFilters"
        @filter-reset="resetFilters"
      />

      <b-table
        id="kardex-table"
        responsive
        :head-variant="headVariant"
        :bordered="bordered"
        :per-page="perPage"
        :busy="loading"
        :items="items"
        :fields="fields"
        class="d-none d-md-table shadow-sm !rounded"
      >
        <template #head()="data">
          <span class="text-black">{{
            $t(labelHeader(data.label.toLowerCase()))
          }}</span>
        </template>

        <template #cell(movementDate)="data">
          {{ formatDate(data.item.movementDate) }}
        </template>

        <template #cell(movementTypeName)="data">
          {{ movementTypeText(data.item) }}
        </template>

        <template #cell(documentNumber)="data">
          {{ data.item.documentNumber || "-" }}
        </template>

        <template #cell(supplierName)="data">
          {{ data.item.supplierName || "-" }}
        </template>

        <template #cell(entrada)="data">
          <span class="text-success">{{ data.item.entrada || 0 }}</span>
        </template>

        <template #cell(salida)="data">
          <span class="text-danger">{{ data.item.salida || 0 }}</span>
        </template>

        <template #cell(stockBefore)="data">
          {{ data.item.stockBefore || 0 }}
        </template>

        <template #cell(stockAfter)="data">
          {{ data.item.stockAfter || 0 }}
        </template>

        <template #cell(notes)="data">
          {{ data.item.notes || 0 }}
        </template>

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle ml-50" />
            <strong>{{ $t("loading") }}...</strong>
          </div>
        </template>
      </b-table>

      <div class="mx-2 d-none d-md-table">
        <b-row>
          <b-col cols="12" md="2" class="mb-2">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">
                {{ $t("perPage") }}
              </label>
              <b-form-select
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                class="w-50"
                @change="handlePerPageChange"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="10"
            class="d-flex align-items-center justify-content-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              pills
              first-number
              last-number
              @change="handlePageChange"
            >
              <template #prev-text>
                <feather-icon size="18" icon="ChevronLeftIcon" />
              </template>
              <template #next-text>
                <feather-icon size="18" icon="ChevronRightIcon" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>

      <div class="d-block d-md-none mt-1 px-2">
        <b-list-group>
          <b-list-group-item
            v-for="item in items"
            :key="item.guid || item.id || `${item.date}-${item.stockAfter}`"
            class="d-flex flex-column align-items-start border border-primary rounded mb-1"
          >
            <strong>{{
              item.movementTypeName ||
              item.movementTypeCode ||
              item.type ||
              "N/A"
            }}</strong>
            <span
              >{{ $t(labelHeader("date")) }}:
              {{ formatDate(item.movementDate) }}</span
            >
            <span
              >{{ $t(labelHeader("document")) }}:
              {{ item.movementTypeName || "-" }}</span
            >
            <span
              >{{ $t(labelHeader("supplier")) }}:
              {{ item.supplierName || item.nameSupplier || "-" }}</span
            >
            <span
              >{{ $t(labelHeader("entry")) }}:
              {{ item.entry || item.input || 0 }}</span
            >
            <span
              >{{ $t(labelHeader("output")) }}:
              {{ item.output || item.exit || item.out || 0 }}</span
            >
            <span
              >{{ $t(labelHeader("stockafter")) }}:
              {{ item.stockAfter || 0 }}</span
            >
          </b-list-group-item>
          <b-list-group-item v-if="items.length === 0" class="text-center">
            {{ $t("notRegister") }}
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";
import {
  BAlert,
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BCol,
  BFormGroup,
  BFormSelect,
  BListGroup,
  BListGroupItem,
  BPagination,
  BRow,
  BSpinner,
  BTable,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Filterss from "../../components/filters/Filterss.vue";
import { allProducts } from "@core/api/request/products";
import { getInventoryProductKardex } from "@core/api/request/inventories";
import { getParams } from "@core/utils/utils";

export default {
  components: {
    BAlert,
    BButton,
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BCol,
    BFormGroup,
    BFormSelect,
    BListGroup,
    BListGroupItem,
    BPagination,
    BRow,
    BSpinner,
    BTable,
    Filterss,
    vSelect,
  },
  data: () => ({
    model: "inventories",
    companyGuid: null,
    guidProduct: null,
    loading: false,
    products: [],
    items: [],
    totalRows: 0,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    hasNextPage: true,
    appliedFilters: {},
    headVariant: "light",
    bordered: true,
    fields: [
      { label: "date", key: "movementDate", sortable: true },
      { label: "movementType", key: "movementTypeName", sortable: true },
      { label: "document", key: "documentNumber", sortable: true },
      { label: "supplier", key: "supplierName", sortable: true },
      { label: "entry", key: "entrada", sortable: false },
      { label: "output", key: "salida", sortable: false },
      { label: "stockBefore", key: "stockBefore", sortable: false },
      { label: "stockAfter", key: "stockAfter", sortable: false },
      { label: "notes", key: "notes", sortable: false },
    ],
    fildsToFilters: [
      {
        name: "dateFrom",
        title: "dateFrom",
        placeholder: "dateFrom",
        type: "date",
        visible: true,
      },
      {
        name: "dateTo",
        title: "dateTo",
        placeholder: "dateTo",
        type: "date",
        visible: true,
      },
    ],
  }),
  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.guidProduct = null;
      this.items = [];
      this.loadProducts();
    },
  },
  created() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.loadProducts();
  },
  methods: {
    label(field) {
      return `pages.inventories.kardex.${field}`;
    },
    labelHeader(field) {
      return `pages.inventories.kardex.tableHeader.${field}`;
    },
    normalizeArray(resp) {
      const data = _.get(resp, "data");
      return (
        data?.items || data?.data?.items || (Array.isArray(data) ? data : [])
      );
    },
    async loadProducts() {
      if (!this.companyGuid) {
        this.products = [];
        return;
      }
      try {
        this.loading = true;
        const resp = await allProducts(
          getParams(["page,1", "rows,999", `guidCompany,${this.companyGuid}`]),
        );
        this.products = this.normalizeArray(resp);
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      } finally {
        this.loading = false;
      }
    },
    async loadKardex() {
      if (!this.companyGuid || !this.guidProduct) {
        this.items = [];
        this.totalRows = 0;
        this.hasNextPage = true;
        return;
      }
      try {
        this.loading = true;
        const resp = await getInventoryProductKardex(
          this.guidProduct,
          this.chargeParams(),
        );
        const data = _.get(resp, "data");
        this.items = data?.items || [];
        this.totalRows = data?.totalRows || 0;
        this.hasNextPage = data?.currentPage < data?.totalPages || 0;
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      } finally {
        this.loading = false;
      }
    },
    chargeParams() {
      const arrParams = [
        `page,${this.currentPage}`,
        `rows,${this.perPage}`,
        `guidCompany,${this.companyGuid}`,
      ];
      Object.keys(this.appliedFilters).forEach((key) => {
        const value = this.appliedFilters[key];
        if (value !== null && value !== undefined && value !== "") {
          arrParams.push(`${key},${value}`);
        }
      });
      return getParams(arrParams);
    },
    onProductChange() {
      this.currentPage = 1;
      this.loadKardex();
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadKardex();
    },
    handlePerPageChange() {
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadKardex();
    },
    applyFilters(filters) {
      this.appliedFilters = filters || {};
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadKardex();
    },
    resetFilters() {
      this.appliedFilters = {};
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadKardex();
    },
    formatDate(value) {
      if (!value) return "-";
      return this.moment(value).isValid()
        ? this.moment(value).format("DD/MM/YYYY HH:mm")
        : value;
    },

    movementTypeText(item) {
      return (
        item.movementTypeName ||
        item.movementType ||
        item.movementTypeCode ||
        item.type ||
        "N/A"
      );
    },
    goBack() {
      this.$router.push({ name: "inventories" });
    },
    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
